import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useTranslate } from '@tolgee/react';

import { ETolgeeNamespaces } from '~/shared/enums';
import { useFetchHomePrograms } from '~/shared/hooks/useFetchHomePrograms';
import { useUser } from '~/shared/hooks/useUser';
import { resolveCanManageTeamOrders } from '~/shared/utils/resolveCanManageTeamOrders';

import { HomeActionCardViewModel } from '../types';
import { buildHomeActionCards } from '../utils/buildHomeActionCards';

export function useHomeActionCards() {
  const router = useRouter();
  const { t } = useTranslate(ETolgeeNamespaces.HOME);
  const { data, isLoading } = useFetchHomePrograms();
  const { accessRoles } = useUser();

  const cards = useMemo<HomeActionCardViewModel[]>(() => {
    if (!data) {
      return [];
    }

    return buildHomeActionCards({
      ...data,
      isTeamManager: resolveCanManageTeamOrders(data.isTeamManager, accessRoles)
    }).map(card => ({
      id: card.id,
      title: t(card.titleKey),
      description: t(card.descriptionKey),
      actionLabel: t(card.actionLabelKey),
      descriptionTitle: card.descriptionTitleKey
        ? t(card.descriptionTitleKey)
        : undefined,
      badge: card.badge
        ? {
            label: t(card.badge.labelKey),
            variant: card.badge.variant
          }
        : undefined,
      onAction: () => {
        void router.push(card.href);
      }
    }));
  }, [accessRoles, data, router, t]);

  return { cards, isLoading };
}
